import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { DropdownToggle } from 'approot/shared/dropdown/dropdown.style';
import { DropdownItemSwitch } from 'approot/shared/dropdown/dropdown-item.style';
import { SwitchStyled } from 'approot/shared/switch/switch.style';
import { spacing4, spacing8 } from 'approot/shared/styles/spacing.style';
import { SettingsGroup } from 'approot/activity-builder/settings/settings.style';

export const ColumnSettings = styled.div`
  display: flex;
  height: ${rem(32)};
`;

export const ColumnDropdownButton = styled(DropdownToggle)`
  border: none;
  height: ${rem(32)};
  white-space: nowrap;
`;

export const ColumnDropdownSwitch = styled(DropdownItemSwitch)`
  justify-content: space-between;
  padding-left: ${rem(spacing4)};
  padding-right: ${rem(spacing4)};

  ${SwitchStyled} {
    min-width: ${rem(48)};
  }
`;

export const ColumnSettingsGroup = styled(SettingsGroup)`
  padding-left: ${rem(spacing4)};
  padding-right: ${rem(spacing4)};
`;

export const ColumnSettingsBordersTabsWrapper = styled.div`
  margin-bottom: ${rem(spacing4)};
  margin-left: ${rem(-spacing8)};
  margin-right: ${rem(-spacing8)};
`;
